/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulationPdf200,
  GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulationPdf401,
  GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulationPdf404,
  GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulationPdf500,
  GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulationPdfPathParams,
  GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulationPdfQueryResponse,
} from "../../types/classPlanningGradeAndFrequenceConfigurationController/GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulationPdf.ts";

export const getApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulationPdfPathParamsSchema =
  z.object({
    courseRegistrationId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulationPdfPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulationPdf200Schema =
  z.instanceof(
    File,
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulationPdf200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulationPdf401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulationPdf401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulationPdf404Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulationPdf404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulationPdf500Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulationPdf500>;

export const getApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulationPdfQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulationPdf200Schema,
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulationPdfQueryResponse>;
